// extracted by mini-css-extract-plugin
export var searchHeader = "_m-0";
export var searchHeaderDark = "_m-1";